import { ConvertedRealEstate } from '../../../../../@types/real-estate-api-types'

const getAddress = (object: ConvertedRealEstate) => {
  return `${object.listing?.street} ${object.listing?.houseNumber}`.toLowerCase()
}

export const filterObjectsBySearchPhrase = (objects: ConvertedRealEstate[] | undefined, search: string) => {
  if (!objects) {
    return []
  }
  const lowerCaseSearch = search.toLowerCase()
  return search.length !== 0
    ? objects.filter((object: ConvertedRealEstate) => getAddress(object).includes(lowerCaseSearch))
    : objects
}
